export default __webpack_public_path__ + "static/media/image-main-1-m@3x.a34e0632.png";